'use client'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import SearchPageDS from './search-page-ds'
import SearchPageLegacy from './search-page-legacy'

export default function SearchPage() {
  if (shouldUseDesignSystem()) return <SearchPageDS />
  return <SearchPageLegacy />
}
